import { render } from "./DraggableGesture.vue?vue&type=template&id=0e4244b9&scoped=true"
import script from "./DraggableGesture.vue?vue&type=script&lang=js"
export * from "./DraggableGesture.vue?vue&type=script&lang=js"

import "./DraggableGesture.vue?vue&type=style&index=0&id=0e4244b9&lang=less&scoped=true"
import "./DraggableGesture.vue?vue&type=style&index=1&id=0e4244b9&lang=less"
script.render = render
script.__scopeId = "data-v-0e4244b9"

export default script